import { Global, css } from "@emotion/react";

import { getThemeValue } from "@theme/components";
import { Normalize } from "@theme/components/GlobalStyle/Normalize";

export const GlobalStyle = () => {
  return (
    <>
      {/* Normalize css to provide better base
        github.com/necolas/normalize.css
      */}
      <Normalize />

      <Global
        styles={(t) => css`
          /* Remove Reach UI styles warnings */
          :root {
            --reach-tabs: 1;
          }

          [data-reach-disclosure-button] {
            background: transparent;
            border: none;
            padding: 0;
          }

          [data-reach-disclosure-panel]:focus {
            outline: none;
          }

          /* remove fade in on gatsby-images with loading="eager" */
          .gatsby-image-wrapper [data-main-image][loading="eager"] {
            transition: opacity 0s linear;
          }

          /* Remove recaptcha badge see: https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed */
          .grecaptcha-badge {
            visibility: hidden;
          }

          /* Hide Coupon Popups */
          html div#__genieContainer,
          html div#cently-portal-popover,
          html div#honeyContainer {
            display: none !important;
            visibility: hidden !important;
          }

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            font-weight: 400;
          }

          .paymentInputLabel {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            z-index: 3;
            text-transform: uppercase;
            pointer-events: none;
            transition: font-size 0.3s ease, top 0.3s ease;
            color: black;
          }

          #cardNumber,
          #exp,
          #cvv {
            height: 50px;
            border-radius: 0;
            position: relative;
            background: white;
            padding-right: 1rem;
            padding-left: 1rem;
            padding-bottom: 0;
            z-index: 2;
            border: none;
            outline-color: ${getThemeValue(t, "colors.grey400")};
            outline-style: solid;
            outline-width: 1px;
          }

          #cardNumber:hover,
          #exp:hover,
          #cvv:hover,
          #cardNumber.braintree-hosted-fields-focused,
          #exp.braintree-hosted-fields-focused,
          #cvv.braintree-hosted-fields-focused {
            outline-color: ${getThemeValue(t, "colors.goldPrimary")};
            outline-width: 2px;
          }

          #cardNumber.braintree-hosted-fields-focused + .paymentInputBorder,
          #cvv.braintree-hosted-fields-focused + .paymentInputBorder,
          #exp.braintree-hosted-fields-focused + .paymentInputBorder {
            display: block;
          }

          #cardNumber.braintree-hosted-fields-focused ~ .paymentInputLabel,
          #cvv.braintree-hosted-fields-focused ~ .paymentInputLabel,
          #exp.braintree-hosted-fields-focused ~ .paymentInputLabel,
          #cardNumber.isFocused ~ .paymentInputLabel,
          #cvv.isFocused ~ .paymentInputLabel,
          #exp.isFocused ~ .paymentInputLabel {
            top: 10px;
            font-size: 10px;
          }

          #cardNumber.isBlurred ~ .paymentInputLabel,
          #cvv.isBlurred ~ .paymentInputLabel,
          #exp.isBlurred ~ .paymentInputLabel {
            color: black;
          }

          /* PHP/Portal Payment Inputs */
          #phpNewPayment,
          #addNewPayment {
            height: 100%;
            display: flex;
            flex-direction: column;
            iframe {
              padding: 0px !important;
            }
          }

          /* Force ketch modals to use Graphik Fonts */
          #lanyard_root * {
            font-family: "Graphik";
          }
        `}
      />
    </>
  );
};
